export const routes = {
  home: '/',
  authentication: {
    login: '/login',
    signup: '/signup',
  },
  onboard: '/onboard',
  landing: {
    features: '/#features',
    stories: '/#stories',
    patients: '/#patients',
    employers: '/#employers',
  },
  employer: {
    base: '/employer',
    newListing: '/newListing',
    listings: '/listings',
    listing: '/listing',
    applications: '/applications',
    profile: '/profile',
  },
  employee: {
    base: '/employee',
    listings: '/listings',
    applications: '/applications',
    profile: '/profile',
  },
};
